<template>
  <v-form :aria-label="$t('Password Recovery')">
    <v-layout justify-center>
      <v-btn to="/login" outline color="primary">
        <v-icon>mdi-chevron-left</v-icon>
        Volver
      </v-btn>
    </v-layout>

    <p style="margin-top: 20px" class="black--text">
      {{ $t('Introduce el correo electrónico con el que accedes normalmente.') }}
      <br />
      {{ $t('Se te enviará un email con las instrucciones para recuperar tu contraseña') }}
    </p>

    <v-text-field
      style="margin-top: 20px"
      :placeholder="$t('usuario@email.com')"
      v-model="passwordRecoveryData.email"
      color="primary"
      autocomplete
      outline
      :label="$t('Usuario')"
      required
      @keypress.enter="passwordRecovery"
    ></v-text-field>
    <v-layout justify-center row>
      <v-flex xs12>
        <v-btn
          @click="passwordRecovery"
          round
          large
          class="my-4 dark--text"
          color="primary"
          v-if="!loading"
        >
          {{ $t('Enviar') }}
        </v-btn>
        <div class="text-center" v-if="loading">
          <v-progress-circular
            :size="70"
            :width="7"
            color="primary"
            indeterminate
          ></v-progress-circular>
        </div>
      </v-flex>
    </v-layout>

    <template v-if="recoverySended">
      <p style="color: #A19E9E; margin-top: 30px">
        {{
          $t(
            'Comprueba tu correo electrónico, en los próximos minutos debes recibir un email con instrucciones para recuperar tu contraseña',
          )
        }}
        <br />
        {{ $t('En caso de no recibir dicho email, puedes ponerte en contacto con nosostros') }}
        <v-btn outline color="primary" href="https://openges.es/">
          Contacto
        </v-btn>
      </p>
    </template>
  </v-form>
</template>

<script>
import authApi from '../services/auth-api.js';
export default {
  data() {
    return {
      formdata: {
        username: '',
        password: '',
        verify: false,
      },
      showPasswordRecovery: false,
      passwordRecoveryData: {
        email: '',
      },
      recoverySended: false,
      loading: false,
    };
  },
  mounted() {},
  methods: {
    passwordRecovery() {
      this.loading = true;
      this.passwordRecoveryData.frontUrl = this.getCurrentHostUrl('/password');
      authApi
        .resetPassword(this.passwordRecoveryData)
        .then(res => {
          this.recoverySended = true;
          this.loading = false;
          //this.$router.push('/login');
        })
        .catch(() => {
          this.loading = false;
        });
    },

    getCurrentHostUrl(url = '') {
      let hostUrl = location.protocol + '//' + location.host;
      return hostUrl + url;
    },
    // submit() {
    //     authApi.login(this.formdata).then(res => {
    //         console.log(res);
    //         localStorage.setItem('token', res.data.access_token);
    //         this.$router.push(this.$route.query.redirect || '/');
    //     })
    //     console.log(this.formdata)
    // }
  },
};
</script>
